<template>
  <div class="container othms" v-show="loaded">


    <!-- <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"></div>
          <div class="header__fixed__center">
            <h1>斐燃生活</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div> -->

    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"></div>
          <div class="header__fixed__center">
            <h1>斐燃生活</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>


    <div class="sticklock" style="box-shadow: none;">
      <div class="block" style="box-shadow: none;">
        <div class="box" >
          <div class="box__title">预约日期</div>
          <div class="datescroll">
            <!-- 1/750*100vw -->
            <ul :style="{'width':dateM.length*211/750*100+'vw'}">
              <li v-for="(item,key) in dateM" @click="paSelectDate(item,key)" :class="dateIndex==key ? 'active' : ''">
                <div class="cont">
                  <!-- cont -->
                  <p class="date">{{item.date}}</p>
                  <p class="week">{{item.week}}</p>
                </div>
              </li>
            </ul>
          </div>
          <div style="width: 20%;">
            <van-dropdown-menu active-color="#1989fa">
              <van-dropdown-item v-model="value1" @change="changedrop" :options="option1" />
            </van-dropdown-menu>
          </div>
        </div>
      </div>

    </div>

    <div class="yd_stadium" v-show="stadium.length>0">
      <div v-for="(item,index) in stadium" :key="index" class="yd_stadium_item" :style="'background-image: url('+item.thumb+')'" @click="toCreatOrder(item)">
        <div class="yd_stadium_item_address">{{item.address}}</div>
        <div class="yd_stadium_item_price">
          <div>门市价：¥{{item.original_fee}}</div>
          <div>平日价：¥{{item.fee}}</div>
          <div>周末价：¥{{item.weekend_fee}}</div>
          <div style="color:red" v-if="item.stock <= 0">剩余{{item.stock}}位</div>
          <div v-else>剩余{{item.stock}}位</div>
        </div>
        <!-- <div class="yd_stadium_item_price">¥{{(item.other_fee/100).toFixed(2)}}</div> -->
      </div>
    </div>
    <div class="yd_stadium" v-show="stadium.length==0">
      <img class="hotsell_cot_tomorrow_emptyimg" src="../../../assets/images/base/emptylist.png" />
      <div class="hotsell_cot_tomorrow_emptytxt">暂无酒店数据，请选择其他日期</div>
    </div>
  </div>
</template>

<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        dateIndex: 0,
        list: [],
        stadium: [],
        loaded: false,
        dateM:[],
        value1:0,
        valuetxt:'上海',
        option1: [
          { text: '上海', value: 0 },
          { text: '北京', value: 1 },
          { text: '广州', value: 2 },
          { text: '深圳', value: 3 },
          { text: '杭州', value: 4 },
          { text: '天津', value: 5 },
          { text: '重庆', value: 6 },
          { text: '南京', value: 7 },
          { text: '西安', value: 8 },
          { text: '昆明', value: 9 },
          { text: '成都', value: 10 },
          { text: '沈阳', value: 11 },
          { text: '大连', value: 12 },
          { text: '青岛', value: 13 },
          { text: '长沙', value: 14 },
        ],
      }
    },
    created() {},
    mounted() {
			this.$loading('加载中');
      this.getInfo()
    },
    activated() {
    },
    methods: {
      changedrop(e){
        console.log(e)
        this.$loading('加载中');
        this.valuetxt=this.option1[e].text
        this.getstadiumvaluetxt()
      },
      getInfo() {
        var $this = this
        if (localStorage.getItem("token")) {
          let param = {
            token: localStorage.getItem("token")
          }
          //
          var qs = require('qs');
          let url = this.api.userApi.getInfo
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            if (result.data) {
              if (result.data.user.name == null || result.data.user.name == undefined || result.data.user.name =='') {
                console.log('fragent跳转index1')
                $this.$router.push({
                  name: 'index'
                })
              } else {
                $this.userInfo = result.data.user
                $this.getdate()
              }
            } else {
              $this.$toast('页面错误')
              $this.$router.push({
                name: 'index'
              })
            }
          }).catch((error) => {
            $this.$toast('未知错误')
            $this.$router.push({
              name: 'index'
            })
          })
          //
        } else {
          $this.$router.push({
            name: 'login'
          })
        }
      },
      paSelectDate(item, index) {
        // console.log(item)
        // console.log(index)
        this.dateIndex = index
        // this.valuetxt='上海'
        // this.value1=0
        this.$loading('加载中');
        this.getstadiumvaluetxt()
        // this.stadium = item.stadiums
      },
      getdate(){
        //
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        // getAgentWeekDays
        var qs = require('qs');
        let url = this.api.userApi.getAgentWeekDays
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.data) {
            // dateM
            let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            for (var i = 0; i < result.data.days.length; i++) {
              var param={
                date:result.data.days[i],
                week:week[new Date((result.data.days[i]).replace(/-/g, "/")).getDay()]
              }
              $this.dateM.push(param)
            }
            this.getstadiumvaluetxt()

          } else {
            $this.$toast(result.msg)
            $this.$router.push({
              name: 'index'
            })
          }
        }).catch((error) => {
          $this.$toast('服务错误')
          $this.$router.push({
            name: 'index'
          })
        })
      },
      getstadiumvaluetxt(){
        //
        var city_value=this.valuetxt
        if(this.valuetxt=='全部'){
          city_value=''
        }

        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          city:city_value,
          date:this.dateM[this.dateIndex].date,
          // type:1,
        }
        console.log(param)
        // getAgentStadiumLis
        // flStadiumLists
        var qs = require('qs');
        let url = this.api.userApi.flStadiumLists
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.data) {
            // option1
            for (var i = 0; i < result.data.length; i++) {
              result.data[i].original_fee=(result.data[i].original_fee/100).toFixed(1)
              result.data[i].fee=(result.data[i].fee/100).toFixed(1)
              result.data[i].weekend_fee=(result.data[i].weekend_fee/100).toFixed(1)
            }
            $this.stadium=result.data
            $this.loaded=true
          } else {
            $this.$toast(result.msg)
            $this.stadium=[]
            // $this.$router.push({
            //   name: 'index'
            // })
          }
          $this.$loading.close()
        }).catch((error) => {
        $this.$loading.close()
          $this.$toast('服务错误')
          // $this.$router.push({
          //   name: 'index'
          // })
        })
      },
      seckillOtherStadiums() {
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        // getAgentSeckillOtherStadiums
        var qs = require('qs');
        let url = this.api.userApi.getAgentSeckillOtherStadiums
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.data) {
            $this.loaded = true
            let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            // for (var i = 0; i < result.data.length; i++) {
            //   result.data[i].simpleDate=(result.data[i].date).substring(5,10)
            //   result.data[i].week=week[(new Date(result.data[i].date)).getDay()]
            // }
            // .replace(/-/g,".")
            for (var i = 0; i < result.data.length; i++) {
              result.data[i].week = week[new Date((result.data[i].date).replace(/-/g, "/")).getDay()]
            }
            // console.log(result)
            $this.list = result.data
            $this.stadium = result.data[0].stadiums
          } else {
            $this.$toast(result.msg)
            $this.$router.push({
              name: 'index'
            })
          }
        }).catch((error) => {
          $this.$toast('服务错误')
          $this.$router.push({
            name: 'index'
          })
        })

      },
      toCreatOrder(item) {
        if(item.tip != '') {
          alert(item.tip)
        }
        // console.log(item)
        if (item.status == 2) {
          this.$toast('该酒店暂时不可预约')
          return
        }
        item.day=this.dateM[this.dateIndex].date

        var $this = this
        $this.$loading('资格查询中...');
        sessionStorage.setItem('yuandtt', JSON.stringify(item))
        setTimeout(function() {
          $this.$loading.close()
          $this.$router.push({
            name: 'fragentCreateOrder'
          })
        }, 500)
      },
    },
    destroyed: function() {}
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .othms {
    .sticklock {
      position: relative;
      z-index: 12;
      width: 100%;
      height: 412*@vm_base;
    }

    .block {
      // padding:0 30*@vm_base;
      height: 412*@vm_base;
      padding: 0;
      margin-top: 90*@vm_base;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 98;
      background: #fff;
      width: 100%;

      .box {
        position:relative;
        margin-top:16*@vm_base;
        padding:30*@vm_base;
        background:#fff;
        box-shadow:none;
        border-radius:6px;
      }

      .box__title {
        margin-bottom: 24*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 45*@vm_base;

        .txt {
          float: right;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: rgba(255, 85, 46, 1);
          line-height: 33*@vm_base;
        }

        a {
          float: right;
          font-size: 26*@vm_base;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 45*@vm_base;
        }
      }

      .box__word {
        p {
          font-size: 26*@vm_base;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 42*@vm_base;
        }
      }
    }

    .datescroll {
      overflow-x: auto;

      ul {
        // width:7*211*@vm_base;
      }

      li {
        float: left;
        padding: 16*@vm_base;
      }

      .cont {
        width: 179*@vm_base;
        padding: 32*@vm_base 0;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid #747272;
        text-align: center;
      }

      .conto {
        width: 179*@vm_base;
        padding: 32*@vm_base 0;
        background: rgba(245, 245, 245, 1);
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        text-align: center;
      }

      .date {
        font-size: 28*@vm_base;
        font-weight: 600;
        color: rgba(102, 102, 102, 1);
        line-height: 45*@vm_base;
      }

      .week {
        font-size: 26*@vm_base;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 37*@vm_base;
      }

      .active {
        .cont {
          background: rgba(255, 255, 255, 1);
          box-shadow: 4px 6px 24px 0px rgba(177, 147, 69, 0.2);
          border: 1px solid #ff6600;
        }

        .date {
          color: #ff6600;
        }

        .week {
          color: #ff6600;
        }
      }
    }

    .yd_stadium {
      width: 100%;
      padding: 40*@vm_base 32*@vm_base;

      .yd_stadium_item {
        position: relative;
        width: 100%;
        height: 428*@vm_base;
        background-size: auto 428*@vm_base;
        background-position: center;
        background-repeat: no-repeat;
        margin-bottom: 60*@vm_base;
        border-radius: 12*@vm_base;
        .yd_stadium_item_address{
          position: absolute;
          bottom: 0;
          left: 0;
          padding:8*@vm_base 16*@vm_base;
          border-radius: 24*@vm_base;
          background: rgba(0,0,0,.3);
          font-size: 28*@vm_base;
          color: #FFFFFF;
          margin-bottom: 16*@vm_base;
          max-width: calc(100% - 32*@vm_base);
          margin-left: 16*@vm_base;
        }
        // .yd_stadium_item_price{

        // }
        .yd_stadium_item_price{
          float: right;
          background: rgba(0,0,0,.3);
          font-size: 28*@vm_base;
          color: #FFFFFF;
          margin-top: 16*@vm_base;
          margin-right: 16*@vm_base;
          padding:8*@vm_base 16*@vm_base;
          border-radius: 12*@vm_base;
          // text-align: right;
        }
      }
    }
  }

  .hotsell_cot_tomorrow_emptyimg {
    width: 50%;
    margin: 0 auto;
    margin-top: 50*@vm_base;
  }

  .hotsell_cot_tomorrow_emptytxt {
    width: 100%;
    text-align: center;
    font-size: 32*@vm_base;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/unpublic/agent/fragent.vue